import { deliveryRequestStrings } from '@data/deliveryRequest';
import { createStrings } from '@utils/local';
import type { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: `${deliveryRequestStrings.deliveryCase}一覧`,
  },
});

export const meta: PageMeta = {
  title: strings.title,
  listed: true,
  staffOnly: true,
  rolesOnly: ['admin', 'FCJapan'],
  order: 4,
};
